"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
/**
 * Renders the ArrowRight icon
 * @param {React.SVGProps<SVGSVGElement>} props - The props for the ArrowRight component
 * @returns {JSX.Element} - The ArrowRight component
 * @example
 * <ArrowRight />
 * @example
 * <ArrowRight height={24} width={24} />
 * @example
 * <ArrowRight className="custom-class" />
 */
function ArrowRight({ isDecorative, ...props }) {
    return (react_1.default.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
        react_1.default.createElement("path", { d: "M9.00001 15.875L12.88 11.995L9.00001 8.11501C8.81275 7.92817 8.70752 7.67452 8.70752 7.41001C8.70752 7.14549 8.81275 6.89184 9.00001 6.70501C9.39001 6.31501 10.02 6.31501 10.41 6.70501L15 11.295C15.39 11.685 15.39 12.315 15 12.705L10.41 17.295C10.02 17.685 9.39001 17.685 9.00001 17.295C8.62001 16.905 8.61001 16.265 9.00001 15.875Z", fill: "#707070" }),
        !isDecorative && react_1.default.createElement("title", null, "arrow right icon")));
}
exports.default = ArrowRight;
